import Head from 'next/head';

interface PageTitleProps {
  title?: string;
}

export default function PageTitle(props: PageTitleProps) {
  const { title } = props;
  const baseTitle = 'ylah.board';
  const pageTitle = title ? `${title} | ${baseTitle}` : baseTitle;

  return (
    <Head>
      <title>{pageTitle}</title>
    </Head>
  );
}
